// Tiny in-memory mailbox for passing picker results between screens.
// Caller sets pending key + values; consumer reads + clears on focus.

type PickResult = { id: string; name: string; field: string; key: string };
let pending: PickResult | null = null;

export function setPick(result: PickResult) {
  pending = result;
}

export function consumePick(key: string): PickResult | null {
  if (pending && pending.key === key) {
    const r = pending;
    pending = null;
    return r;
  }
  return null;
}
